<template>
  <validation-observer ref="validationobserver" v-slot="{ }">
    <b-form @submit.prevent="salvarPrazo">
      <b-card header-tag="header" class="m-3" no-body>
        <template #header>
          <h6 class="mb-0 text-center">
            <span class="titulo-sagres font-weight-bold">
              {{ isEdit ? 'Editar' : 'Cadastrar' }} Prazo de Vencimento
            </span>
            <btn-voltar />
            <b-button class="float-right m-1" size="sm" type="submit">
              <font-awesome-icon icon="save" />
              Salvar
            </b-button>
          </h6>
        </template>
        <b-card-body>
          <b-row>
            <b-col cols="6" xl="3">
              <validation-provider rules="required" v-slot="validationContext" name="exercicio">
                <b-form-group id="input-group-type" label-size="md" label="Exercício (ano)*">
                  <b-form-select id="select-exercicio" v-model="prazo.Exercicio" :options="comboExercicios"
                    :state="getValidationState(validationContext)" :disabled="isEdit">
                  </b-form-select>
                  <b-form-invalid-feedback id="select-exercicio-live-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6" xl="3">
              <validation-provider rules="required" v-slot="validationContext" name="referencia">
                <b-form-group id="input-group-type" label-size="md" label="Referência (mês)*">
                  <b-form-select id="select-referencia" v-model="prazo.Referencia" :options="comboReferencias"
                    @change="atualizarPeriodo" :state="getValidationState(validationContext)" :disabled="isEdit">
                  </b-form-select>
                  <b-form-invalid-feedback id="select-referencia-live-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6" xl="3">
              <validation-provider rules="required" v-slot="validationContext" name="esfera">
                <b-form-group id="input-group-type" label-size="md" label="Esfera">
                  <b-form-select id="select-esfera" v-model="prazo.IdEsfera" :options="comboEsferas"
                    :state="getValidationState(validationContext)" :disabled="isEdit">
                  </b-form-select>
                </b-form-group>
                <b-form-invalid-feedback id="select-esfera-live-feedback">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-col>
            <b-col cols="6" xl="3">
              <b-form-group id="periodo-input-group" label="Período" label-for="input-periodo">
                <b-form-input id="input-periodo" class="w-100" v-model="prazo.PeriodoPrestacao" disabled>
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label-class="text-left" id="data-vencimento-input-group" label="Data de Vencimento *"
                label-for="input-data-vencimento">
                <b-form-datepicker id="input-data-vencimento" v-model="prazo.DataVencimento"
                  placeholder="Selecione uma data" value-as-date label-no-date-selected="Nenhuma data selecionada"
                  reset-button label-reset-button="Limpar" label-help="Use as setas para navegar pelas datas"
                  label-prev-year="Ano anterior" label-prev-month="Mês anterior" label-current-month="Mês atual"
                  label-next-month="Próximo mês" label-next-year="Próximo ano">
                </b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label-class="text-left" id="data-vencimento-original-input-group"
                label="Data de Vencimento Original*" label-for="input-data-vencimento-original">
                <b-form-datepicker id="input-data-vencimento-original" v-model="prazo.DataVencimentoOriginal" reset-button
                  label-reset-button="Limpar" placeholder="Selecione uma data" value-as-date
                  label-no-date-selected="Nenhuma data selecionada" label-help="Use as setas para navegar pelas datas"
                  label-prev-year="Ano anterior" label-prev-month="Mês anterior" label-current-month="Mês atual"
                  label-next-month="Próximo mês" label-next-year="Próximo ano">
                </b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group id="justificativa-input-group" label="Justificativa" label-for="input-justificativa">
                <b-form-input id="input-justificativa" class="w-100" v-model="prazo.Justificativa">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-form>
  </validation-observer>
</template>

<script lang="ts">
import { Vue, Component, Ref } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import BtnVoltar from '@/components/shared/BtnVoltar.vue'

import { ValidationProvider, ValidationObserver } from "vee-validate";
import { store } from "@/store";
import { UtilsTS } from '@/utilsts'

import prazosService from "@/services/administracao/prazosService";
import { PrazoDeVencimento } from '@/types/administracao/prazo-de-vencimento';
import { SelectValue } from '@/types/select-value';

const CompProps = Vue.extend({
  name: 'EditarPrazoVencimento',
  components: {
    BtnVoltar,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    idprazo: {
      type: String,
      required: false
    }
  }
})

@Component
export default class EditarPrazoVencimento extends mixins(UtilsTS, CompProps) {
  @Ref('validationobserver') validationobserver: InstanceType<typeof ValidationObserver>
  comboEsferas: SelectValue[] = []
  comboExercicios: SelectValue[] = []
  comboReferencias: SelectValue[] = []
  prazo = new PrazoDeVencimento()

  get isEdit() {
    return this.idprazo !== undefined && this.idprazo !== null
  }

  async salvarPrazo(): Promise<void> {
    try {
      store.blockScreen = true
      const isValid = await this.validationobserver.validate();
      if (!isValid) {
        console.error(this.validationobserver)
        return
      }
      const response = this.isEdit ? await prazosService.editarPrazoVencimento(this.prazo) : await prazosService.criarPrazoVencimento(this.prazo);
      if (response && response.status == 200) {
        this.$toast.success(`Prazo ${this.isEdit ? 'editado' : 'cadastrado'} com sucesso!`);
        this.$router.push("/seguranca-administracao/prazos-vencimento");
      } else {
        this.$toast.error(response.data.msg || "Erro ao salvar prazo de vencimento");
      }
    } catch (e: any) {
      console.error('Erro ao salvar prazo de vencimento', e, this.prazo)
      this.$toast.error(e.message || "Erro ao salvar prazo de vencimento")
    } finally {
      store.blockScreen = false
    }
  }
  getValidationState({ dirty, validated, valid = null }): any {
    return dirty || validated ? valid : null;
  }
  atualizarPeriodo(): void {
    if (this.prazo.Referencia === 99 || this.prazo.Referencia === 999)
      this.prazo.PeriodoPrestacao = 'ANUAL'
    else
      this.prazo.PeriodoPrestacao = 'MENSAL'
  }

  async mounted(): Promise<void> {
    try {
      store.blockScreen = true
      if (this.isEdit) {
        const prazoApi = await prazosService.getPrazoVencimento(this.idprazo)
        if (prazoApi && prazoApi.status === 200) {
          this.prazo = Object.assign(this.prazo, prazoApi.data)
          this.prazo.tratarDadosDaAPI()
        } else {
          this.$router.push("/seguranca-administracao/prazos-vencimento");
          this.$toast.error(prazoApi.data.msg || "Erro ao carregar prazo de vencimento");
        }
      }
      const combos = await prazosService.getCombos()
      this.comboExercicios = combos.exercicios.map(ex => ({ text: String(ex), value: ex }))
      this.comboReferencias = combos.referencias.map(ex => ({ text: String(ex), value: ex }))
      this.comboEsferas = combos.esferas.map(esf => ({ text: esf.NmNome, value: esf.IdEsfera }))
    } catch (e: any) {
      console.error('Erro ao montar edição de prazos de vencimento', e)
      this.$router.push("/seguranca-administracao/prazos-vencimento");
      this.$toast.error(e.message || "Erro ao carregar prazo de vencimento");
    } finally {
      store.blockScreen = false
    }
  }
};
</script>

<style></style>